// extracted by mini-css-extract-plugin
module.exports = {"root":"PropertyPagination_root__A3hm7"};